/* eslint-disable @typescript-eslint/naming-convention */
export const EmailExpressions = {
    SUGGESTION_DOMAINS: [
        '12move.nl',
        'casema.nl',
        'chello.nl',
        'gmail.com',
        'hccnet.nl',
        'hetnet.nl',
        'home.nl',
        'hotmail.com',
        'hotmail.nl',
        'kpnmail.nl',
        'kpnplanet.nl',
        'live.nl',
        'msn.com',
        'online.nl',
        'outlook.com',
        'planet.nl',
        'quicknet.nl',
        'asnbank.nl',
        'solcon.nl',
        'tele2.nl',
        'telfort.nl',
        'tiscali.nl',
        'upcmail.nl',
        'versatel.nl',
        'devolksbank.nl',
        'wanadoo.nl',
        'wxs.nl',
        'xs4all.nl',
        'yahoo.com',
        'zeelandnet.nl',
        'ziggo.nl',
        'zonnet.nl'
    ],
    SUGGESTION_SECOND_LEVEL_DOMAINS: ['gmail', 'hotmail', 'icloud', 'live', 'me', 'outlook', 'yahoo'],
    SUGGESTION_TOP_LEVEL_DOMAINS: ['nl', 'com'],
    EMAIL_PATTERN: /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-zA-Z]{2,24}(?:\.[a-zA-Z]{2})?)$/,
    EMAIL_MAXLENGTH: 255
};
